import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	textDefaultValueLabel: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.text-default-value-label',
		defaultMessage: 'Default text',
		description:
			'Label above input that informs user the input is setting default value for multiline text field.',
	},
	textDefaultDescriptionLabel: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.text-default-description-label',
		defaultMessage: 'Default description',
		description:
			'Label above input that informs user the input is setting default value for multiline text field for the description field type.',
	},
	environmentDefaultValueLabel: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.environment-default-value-label',
		defaultMessage: 'Default environment',
		description:
			'Label above input that informs user the input is setting default value for multiline text field for the environment field type.',
	},

	textDefaultValueDisabledTooltip: {
		id: 'issue-type-page.field-associated.field-configuration.multiline.text-default-value-disabled-tooltip',
		defaultMessage: 'You can’t change this field’s default text',
		description: 'Tooltip shown when the default text field is disabled and cannot be edited',
	},
	descriptionDefaultValueDisabledTooltip: {
		id: 'issue-type-page.field-associated.field-configuration.multiline.description-default-value-disabled-tooltip',
		defaultMessage: 'You can’t change this field’s default description',
		description:
			'Tooltip shown when the default description field is disabled and cannot be edited',
	},
	environmentDefaultValueDisabledTooltip: {
		id: 'issue-type-page.field-associated.field-configuration.multiline.environment-default-value-disabled-tooltip',
		defaultMessage: 'You can’t change this field’s default environment',
		description:
			'Tooltip shown when the default environment field is disabled and cannot be edited',
	},
	defaultValueTooLongErrorDescription: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.default-value-too-long-error-description',
		defaultMessage: 'Your description is too long.',
		description: 'Validation error shown to the user if too long text is typed in the editor.',
	},
	defaultValueTooLongErrorValue: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.default-value-too-long-error-value',
		defaultMessage: 'Your text is too long.',
		description: 'Validation error shown to the user if too long text is typed in the editor.',
	},
});
